import React from 'react'

import { IconProps } from '../../../common/types'

const DashboardIcon: React.FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.14173 9.06026C2.36173 9.68026 1.86173 10.9903 2.03173 11.9703L3.36173 19.9303C3.60173 21.3503 4.96172 22.5003 6.40172 22.5003H17.6017C19.0317 22.5003 20.4017 21.3403 20.6417 19.9303L21.9717 11.9703C22.1317 10.9903 21.6317 9.68026 20.8617 9.06026L13.9317 3.52028C12.8617 2.66028 11.1317 2.66027 10.0717 3.51027L3.14173 9.06026Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0017 16.1902C10.621 16.1902 9.50171 15.0709 9.50171 13.6902C9.50171 12.3095 10.621 11.1902 12.0017 11.1902C13.3824 11.1902 14.5017 12.3095 14.5017 13.6902C14.5017 15.0709 13.3824 16.1902 12.0017 16.1902Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default DashboardIcon
